import * as vp from 'vopay';
import { useState } from 'react';

import NavList from './NavList';

const { DropDown } = vp;

const UserDropDown = (): React.JSX.Element => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  return (
    <DropDown
      variant="bubble"
      icon={{ icon: 'profile', color: 'primary-dark', size: 'xlg' }}
      isMenuVisible={isMenuVisible}
      onClick={setIsMenuVisible}
    >
      <NavList onClick={() => setIsMenuVisible(false)} />
    </DropDown>
  );
};

export default UserDropDown;
